import { Component, Input } from '@angular/core';

@Component({
	selector: 'notification-trace-results',
	templateUrl: 'notification-trace-results.component.html',
})
export class NotificationTraceResultsComponent  {

	@Input() traceResults: any[];
	@Input() nightMode: boolean;

	constructor() {}
}
